import React from 'react';
import Pomodoro from '../components/timer/Pomodoro';

const Timer = (props) => {
    return(
        <Pomodoro/>
    );
}

export default Timer;